var map = {
	"./center.vue": 21003,
	"./game.vue": 87835,
	"./index.1.vue": 85444,
	"./index.vue": 91400,
	"./manage.vue": 36218,
	"./nft.vue": 18018,
	"./pri.1.vue": 97223,
	"./profile.vue": 1894,
	"./ranking.vue": 85634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45535;